import { useState } from 'react'
import { useLocation, Link as ReactRouterLink } from 'react-router-dom'
import { trackBlogEvent } from '../../utils/analytics'
import { EVENTS } from '../../constants/googleEvents'
import { useGoogleAnalytics } from '../../hooks'
import AnalyticsManager from '../../analytics/AnalyticsManager'
import { ScreenName, ButtonName, ButtonLocation } from '../../analytics'
import {
  Container,
  Link,
  Box,
  Typography,
  AppBar,
  Toolbar,
  Button,
  Hidden,
  IconButton,
  SwipeableDrawer,
  Divider,
  List,
  ListItem,
  Menu,
  MenuItem,
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone'
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone'
import logo from './images/logo-white.png'
const useStyles = makeStyles(() => ({
  link: {
    color: 'white',
    curser: 'pointer',
    '&:hover': {
      borderBottom: '2px solid white',
    },
  },
  redLinks: {
    backgroundColor: '#37A239',
    height: 48,
    ml: 1,
    color: 'white',
  },
  avatar: {
    marginRight: 'auto',
    color: 'white',
    backgroundColor: 'black',
    borderRadius: 0,
    height: 30,
    border: '2px solid gray',
    borderLeft: '12px solid transparent',
    borderRight: '12px solid transparent',
  },
}))
const navigationLinks = [
  { name: 'HOME', href: '/' },
  { name: 'PRODUCTS', href: '/products' },
  { type: 'tutorialMenu' as const },
  { name: 'BLOG', href: '/blog' },
  { name: 'ABOUT', href: '/about' },
  { name: 'CONTACT', href: '/contact' },
  { name: 'PRICING', href: '/pricing' },
]

const tutorialPaths = ['/video-tutorials', '/tutorials']
export const menuBarColor = '#1e3a8a'
export const HeaderMenuItem = () => {
  const [open, setOpen] = useState(false)
  const [tutorialAnchorEl, setTutorialAnchorEl] = useState<null | HTMLElement>(null)
  const location = useLocation()
  const styles = useStyles()
  const analytics = useGoogleAnalytics()
  const tutorialMenuOpen = Boolean(tutorialAnchorEl)
  const isTutorialSectionActive = tutorialPaths.some(
    (p) => location.pathname === p || location.pathname.startsWith(`${p}/`)
  )
  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: menuBarColor,
        height: '8vh',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 'none',
        borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
      }}
    >
      {' '}
      <Container maxWidth="lg">
        <Toolbar sx={{ boxShadow: 'none' }} disableGutters>
          <Box sx={{ marginRight: 'auto', display: 'inline-flex' }}>
            <img
              alt="Scaffolding & Shuttering App"
              src={logo}
              style={{ width: 44, marginBottom: 0 }}
            />
            <Typography variant="h3" color="white" ml={1} mb={0} component="span">
              Scaffolding
              <Box component="span" sx={{ color: '#FF9800' }}>
                app
              </Box>
              .Com™
            </Typography>
          </Box>

          <Hidden mdDown>
            {navigationLinks.map((item) => {
              if ('type' in item && item.type === 'tutorialMenu') {
                return (
                  <Box key="tutorial-menu" sx={{ display: 'inline-flex' }}>
                    <Typography
                      component="button"
                      type="button"
                      variant="h6"
                      onClick={(e) => setTutorialAnchorEl(e.currentTarget)}
                      sx={{
                        color: 'white',
                        mt: 0,
                        px: 0.5,
                        py: 0.5,
                        mx: 0.5,
                        border: 'none',
                        borderBottom: isTutorialSectionActive ? '2px solid white' : '2px solid transparent',
                        background: 'none',
                        cursor: 'pointer',
                        font: 'inherit',
                        fontWeight: 600,
                        '&:hover': { borderBottom: '2px solid white' },
                      }}
                    >
                      TUTORIAL
                    </Typography>
                    <Menu
                      anchorEl={tutorialAnchorEl}
                      open={tutorialMenuOpen}
                      onClose={() => setTutorialAnchorEl(null)}
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                      slotProps={{ paper: { sx: { minWidth: 220 } } }}
                    >
                      <MenuItem
                        component={ReactRouterLink}
                        to="/video-tutorials"
                        onClick={() => setTutorialAnchorEl(null)}
                      >
                        Demo Videos
                      </MenuItem>
                      <MenuItem
                        component={ReactRouterLink}
                        to="/tutorials"
                        onClick={() => setTutorialAnchorEl(null)}
                      >
                        Step-by-Step Guide
                      </MenuItem>
                    </Menu>
                  </Box>
                )
              }
              return (
                <Link
                  className={styles.link}
                  color="textPrimary"
                  component={ReactRouterLink}
                  to={item.href}
                  key={item.name}
                  onClick={() => {
                    if (item.name === 'BLOG') {
                      trackBlogEvent(EVENTS.blog.headerMenuClicked.eventName, {
                        ...EVENTS.blog.headerMenuClicked.eventParams,
                      })
                    }
                  }}
                  sx={{
                    mx: 0.5,
                    borderBottom:
                      item.href == location?.pathname ? '2px solid white' : '',
                  }}
                >
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{ color: 'white', mt: 0, px: 0.5, py: 0.5 }}
                  >
                    {item.name}
                  </Typography>
                </Link>
              )
            })}
            <Box display={'inline-flex'} sx={{ color: 'white' }}>
              <Button
                variant="contained"
                size="medium"
                sx={{
                  backgroundColor: '#4CAF50',
                  ml: 4,
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#45a049'
                  }
                }}
                onClick={() => {
                  analytics(EVENTS.home.loginClicked.eventName, EVENTS.home.loginClicked.eventParams)
                  AnalyticsManager.shared.trackButtonClick(ButtonName.LOGIN, ButtonLocation.HEADER, ScreenName.HOME)
                  window.open('/login')
                }}
              >
                LOGIN
              </Button>
              <Button
                variant="contained"
                size="medium"
                sx={{
                  backgroundColor: '#66BB6A',
                  ml: 1,
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#4CAF50'
                  }
                }}
                onClick={() => {
                  analytics(EVENTS.home.contactUsClicked.eventName, EVENTS.home.contactUsClicked.eventParams)
                  AnalyticsManager.shared.trackButtonClick(ButtonName.CONTACT_US, ButtonLocation.HEADER, ScreenName.HOME)
                  window.open(
                    'https://web.whatsapp.com/send?phone=917976757979'
                  )
                }}
              >
                CONTACT US
              </Button>
            </Box>
          </Hidden>
          <Hidden mdUp>
            <IconButton
              sx={{
                color: 'white',
              }}
              onClick={() => setOpen(true)}
            >
              <MenuTwoToneIcon />
            </IconButton>
          </Hidden>
        </Toolbar>
      </Container>
      <SwipeableDrawer
        anchor="right"
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
      >
        <div
          onClick={() => setOpen(false)}
          onKeyPress={() => setOpen(false)}
          role="button"
          tabIndex={0}
        >
          <IconButton>
            <ChevronRightTwoToneIcon />
          </IconButton>
        </div>
        <Divider />

        <List>
          {navigationLinks.map((item) => {
            if ('type' in item && item.type === 'tutorialMenu') {
              return (
                <Box key="tutorial-submenu">
                  <ListItem sx={{ p: 0, display: 'block' }}>
                    <Link
                      className={styles.link}
                      color="textPrimary"
                      component={ReactRouterLink}
                      to="/video-tutorials"
                      underline="none"
                      onClick={() => setOpen(false)}
                    >
                      <Typography variant="h6" component="span" sx={{ ml: 2, mt: 0, display: 'block', py: 0.5 }}>
                        Demo Videos
                      </Typography>
                    </Link>
                  </ListItem>
                  <ListItem sx={{ p: 0, display: 'block' }}>
                    <Link
                      className={styles.link}
                      color="textPrimary"
                      component={ReactRouterLink}
                      to="/tutorials"
                      underline="none"
                      onClick={() => setOpen(false)}
                    >
                      <Typography variant="h6" component="span" sx={{ ml: 2, mt: 0, display: 'block', py: 0.5 }}>
                        Step-by-Step Guide
                      </Typography>
                    </Link>
                  </ListItem>
                </Box>
              )
            }
            return (
              <ListItem
                sx={{
                  p: 0,
                }}
                key={item.name}
              >
                <Link
                  className={styles.link}
                  color="textPrimary"
                  component={ReactRouterLink}
                  to={item.href}
                  underline="none"
                  key={item.name}
                  onClick={() => {
                    if (item.name === 'BLOG') {
                      trackBlogEvent(EVENTS.blog.headerMenuClicked.eventName, {
                        ...EVENTS.blog.headerMenuClicked.eventParams,
                      })
                    }
                  }}
                >
                  <Typography variant="h6" component="span" sx={{ ml: 2, mt: 0 }}>
                    {item.name}
                  </Typography>
                </Link>
              </ListItem>
            )
          })}
        </List>

        <Divider />
        <List>
          <ListItem>
            <Button
              variant="contained"
              size="medium"
              sx={{
                backgroundColor: '#37A239',

                color: 'white',
              }}
              onClick={() => {
                analytics(EVENTS.home.loginClicked.eventName, EVENTS.home.loginClicked.eventParams)
                AnalyticsManager.shared.trackButtonClick(ButtonName.LOGIN, ButtonLocation.HEADER, ScreenName.HOME)
                window.open('/login')
              }}
            >
              LOGIN
            </Button>
          </ListItem>{' '}
          <ListItem>
            <Button
              variant="contained"
              size="medium"
              sx={{
                backgroundColor: '#37A239',

                color: 'white',
              }}
              onClick={() => {
                analytics(EVENTS.home.contactUsClicked.eventName, EVENTS.home.contactUsClicked.eventParams)
                AnalyticsManager.shared.trackButtonClick(ButtonName.CONTACT_US, ButtonLocation.HEADER, ScreenName.HOME)
                window.open(
                  'https://play.google.com/store/apps/details?id=com.pad.rental.shuttering.store.shutteringapp'
                )
              }}
            >
              Contact Us
            </Button>
          </ListItem>
        </List>
      </SwipeableDrawer>
    </AppBar>
  )
}
